/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPharmacyMynaHomeWebURLResponseTypename = "PutPharmacyMynaHomeWebURLResponse" as const;

/**
 *
 * @export
 * @interface PutPharmacyMynaHomeWebURLResponse
 */
export interface PutPharmacyMynaHomeWebURLResponse {
  /**
   *
   * @type {string}
   * @memberof PutPharmacyMynaHomeWebURLResponse
   */
  mynaHomeWebUrl?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPharmacyMynaHomeWebURLResponse
   */
  readonly __typename?: string;
}

export function PutPharmacyMynaHomeWebURLResponseFromJSON(json: any): PutPharmacyMynaHomeWebURLResponse {
  return PutPharmacyMynaHomeWebURLResponseFromJSONTyped(json, false);
}

export function PutPharmacyMynaHomeWebURLResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPharmacyMynaHomeWebURLResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPharmacyMynaHomeWebURLResponseTypename,

    mynaHomeWebUrl: !exists(json, "myna_home_web_url") ? undefined : json["myna_home_web_url"],
  };
}

export function PutPharmacyMynaHomeWebURLResponseToJSON(object?: PutPharmacyMynaHomeWebURLResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    myna_home_web_url: value.mynaHomeWebUrl,
  };
}
